import React from 'react'
import {Header, List} from 'semantic-ui-react'

const PrioritizeMockResources = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Prioritize Mock Resources</Header>
      <p>
        In some cases you may want to prioritize multiple resources that have conflicting paths so that
        you ensure more explicit path matches are served before those that may match by parameter values
        or wildcard specification.
      </p>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to a service/version/environment combo you plan to work with.</List.Item>
        <List.Item>2. Click on the "Resources" tab</List.Item>
        <List.Item>3. Click the "Edit" symbol for the resource you intend to work with</List.Item>
        <List.Item>4. Change the weight of the resource to reflect where you want the resource to reside in the
          list.</List.Item>
        <List.Item>5. You'll need to review the weights of other resources to order the way you prefer.</List.Item>
      </List>
    </div>
  )
}

export {PrioritizeMockResources}

export default PrioritizeMockResources